import { v4 as uuidV4 } from 'uuid';
import apigeeHMAC from '../../utils/apigeeHMAC';
import { ReduxState } from '../../types';

const body = '';
const bipEnrollmentPath =
  '/payments/digital/v1/supplier_management/supplier_onboarding_enrolments/';
const auth = (currentState: ReduxState, httpMethod: string, resourcePath: string) => {
  const apigeeUrl = currentState.getIn(['config', 'apigeeUrl']) as string;
  const hostname = apigeeUrl.replace('https://', '');
  return apigeeHMAC({
    clientKey: process.env.AXP_BIP_APIGEE_KEY as string,
    clientSecret: process.env.AXP_BIP_APIGEE_KEY_SEC as string,
    httpMethod,
    resourcePath,
    host: hostname,
    port: '443',
  }).render(body);
};

const getSupplierOnboardingDetails = {
  fetch: (id: string, action: string, state: ReduxState) => ({
    url: `${state.getIn(['config', 'apigeeUrl'])}${bipEnrollmentPath}${id}`,
    opts: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-AMEX-API-KEY': process.env.AXP_BIP_APIGEE_KEY as string,
        Authorization: auth(state, 'GET', `${bipEnrollmentPath}${id}`),
        correlation_id: uuidV4(),
      },
    },
  }),
};
export default getSupplierOnboardingDetails;
